<template>
  <div>
    <v-flex d-flex lg12 md12 sm12 xs12>
      <v-flex d-flex lg6 md6 sm6 xs12>
        <v-flex d-flex lg4 md4 sm6 xs6>
          <v-btn color="success" small @click="createCategory()">
            <v-icon dark>add</v-icon>
            {{$tc('category')}}
          </v-btn>
        </v-flex>
        <v-layout row wrap>
          <v-flex d-flex lg12 md12 sm12 xs12>
            <table style="text-align:center;width: 100%" v-if="categories && categories.length > 0">
              <thead>
                <tr>
                  <th>{{$t('name')}}</th>
                  <th>{{$t('order')}}</th>
                  <th>{{$t('actions')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(category, index) in categories" :key="index+100">
                  <td>{{getName(category.name)}}</td>
                  <td>{{category.order}}</td>
                  <td>
                    <v-btn color="error" small @click="removeCategory(index)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex lg6 md6 sm6 xs12>
        <v-flex d-flex lg3 md3 sm4 xs6>
          <v-btn color="success" small @click="createType()">
            <v-icon dark>add</v-icon>
            {{$t('type')}}
          </v-btn>
        </v-flex>
        <v-layout row wrap>
          <v-flex d-flex lg12 md12 sm12 xs12>
            <table style="text-align: center; width: 100%" v-if="types && types.length > 0">
              <thead>
                <tr>
                  <th>{{$t('name')}}</th>
                  <th>{{$t('order')}}</th>
                  <th>{{$t('actions')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(type, index) in types" :key="index+200">
                  <td>{{getName(type.name)}}</td>
                  <td>{{type.order}}</td>
                  <td>
                    <v-btn color="error" small @click="removeType(index)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
    <v-dialog v-model="dialogCategory" width="500">
      <v-card>
        <v-card-title class="headline primary" color="primary" primary-title>{{$t('addCategory')}}</v-card-title>

        <v-card-text>
          <v-flex d-flex lg12 md12 sm12 xs12>
            <v-tabs color="primary" fixed-tabs v-model="categoryTabs">
              <v-tab
                :key="index + 100"
                v-for="(lang, index) in currentCategory.name"
              >{{lang.language.name}}</v-tab>
              <v-tab-item :key="index + 200" v-for="(lang, index) in currentCategory.name">
                <v-container fluid grid-list-xl>
                  <v-layout wrap>
                    <v-flex d-flex lg12 md12 sm12 xs12>
                      <IgTextField
                        :disabled="!Edit"
                        :rules="[v => !lang.language.required || rules.vacio(v, 'name')]"
                        :status="true"
                        :label="$t('name')"
                        v-model="lang.text"
                      ></IgTextField>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
            </v-tabs>
          </v-flex>
          <v-select
            :disabled="!Edit"
            :rules="[v => rules.vacio(v, 'order')]"
            :items="rangeSelect"
            :label="$t('order')"
            v-model="currentCategory.order"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="dialogCategory=false" small>{{$t('cancel')}}</v-btn>
          <v-btn @click="addCategory()" color="success" small>{{$t('save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogType" width="500">
      <v-card>
        <v-card-title class="headline primary" color="primary" primary-title>{{$t('addType')}}</v-card-title>

        <v-card-text>
          <v-flex d-flex lg12 md12 sm12 xs12>
            <v-tabs color="primary" fixed-tabs v-model="typeTabs">
              <v-tab
                :key="index + 100"
                v-for="(lang, index) in currentType.name"
              >{{lang.language.name}}</v-tab>
              <v-tab-item :key="index + 200" v-for="(lang, index) in currentType.name">
                <v-container fluid grid-list-xl>
                  <v-layout wrap>
                    <v-flex d-flex lg12 md12 sm12 xs12>
                      <IgTextField
                        :disabled="!Edit"
                        :rules="[v => !lang.language.required || rules.vacio(v, 'name')]"
                        :status="true"
                        :label="$t('name')"
                        v-model="lang.text"
                      ></IgTextField>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
            </v-tabs>
          </v-flex>
          <v-select
            :disabled="!Edit"
            :rules="[v => rules.vacio(v, 'order')]"
            :items="rangeSelect"
            :label="$t('order')"
            v-model="currentType.order"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="dialogType=false" small>{{$t('cancel')}}</v-btn>
          <v-btn @click="addType()" color="success" small>{{$t('save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import rules from '../../../helpers/rules'
import { mapActions, mapState } from 'vuex'
import queueToast from '../../../helpers/queueToast'
import { rangexy } from '../../../helpers'

export default {
  name: 'tabCategory',
  mixins: [rules],
  props: {
    Edit: {
      required: false,
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      types: [],
      categories: [],
      dialogCategory: false,
      dialogType: false,
      currentCategory: {},
      currentType: {},
      categoryOrder: '0',
      typeOrder: '0',
      rangeValue: 0,
      rangeSelect: [],
      typeTabs: '0',
      categoryTabs: '0'
    }
  },
  watch: {
    currentAct: {
      handler: function(val) {
        this.categories = val ? val.categoryAspects : []
        this.types = val ? val.typeAspects : []
        this.$emit('updateCategory', this.categories)
        this.$emit('updateType', this.types)
      },
      deep: true
    },
    categories(val) {
      this.updateCategoryOrder()
    },
    types(val) {
      this.updateTypeOrder()
    }
  },
  mounted() {
    this.rangeValue = rangexy(0, 99)
    let me = this
    this.rangeValue.forEach(item => {
      me.rangeSelect.push({
        text: item + '',
        value: item + ''
      })
    })
  },
  computed: {
    ...mapState({
      currentAct: state => state.acts.actSelected,
      languages: state => state.languages.listLanguages
    })
  },
  methods: {
    updateTypeOrder() {
      let orders = (this.types || []).map(item => item.order)
      let maxOrder = orders.length ? Math.max(...orders) : 0
      this.typeOrder = maxOrder + 1 + ''
    },
    updateCategoryOrder() {
      let orders = (this.categories || []).map(item => item.order)
      let maxOrder = orders.length ? Math.max(...orders) : 0
      this.categoryOrder = maxOrder + 1 + ''
    },
    typeTemplate() {
      let template = {}
      template.name = this.setComplexLanguage()
      template.order = this.typeOrder

      return template
    },
    categoryTemplate() {
      let template = {}
      template.name = this.setComplexLanguage()
      template.order = this.categoryOrder

      return template
    },
    addType() {
      const error = this.verifyContent(this.currentType)
      if (!error.result) {
        queueToast(error.message)
        return
      }

      let index = this.types.findIndex(
        type => type.order == this.currentType.order
      )
      if (index != -1) {
        this.types.forEach((type, aIndex) => {
          if (aIndex >= index) {
            type.order++
          }
        })
      }
      this.currentType.name = this.getComplexLanguage(this.currentType.name)
      this.types.push(Object.assign({}, this.currentType))
      this.types.sort((a, b) => a.order - b.order)
      this.currentType = {}
      this.dialogType = false
      this.$emit('updateType', this.types)
    },
    addCategory() {
      const error = this.verifyContent(this.currentCategory)
      if (!error.result) {
        queueToast(error.message)
        return
      }
      let index = this.categories.findIndex(
        category => category.order == this.currentCategory.order
      )
      if (index != -1) {
        this.categories.forEach((category, aIndex) => {
          if (aIndex >= index) {
            category.order++
          }
        })
      }
      this.currentCategory.name = this.getComplexLanguage(
        this.currentCategory.name
      )
      this.categories.push(Object.assign({}, this.currentCategory))
      this.categories.sort((a, b) => a.order - b.order)
      this.currentCategory = {}
      this.dialogCategory = false
      this.$emit('updateCategory', this.categories)
    },
    removeType(indice) {
      if (this.types.length === 1) {
        this.types = []
        this.$emit('updateType', this.types)
        return
      }
      let temp = this.types.splice(indice, 1)
      this.types.forEach((type, index) => (type.order = index + 1))
      this.$emit('updateType', this.types)
    },
    removeCategory(indice) {
      if (this.categories.length === 1) {
        this.categories = []
        this.$emit('updateCategory', this.categories)
        return
      }
      let temp = this.categories.splice(indice, 1)
      this.categories.forEach((category, index) => (category.order = index + 1))
      this.$emit('updateCategory', this.categories)
    },
    createCategory() {
      this.categoryTabs = '0'
      this.dialogCategory = true
      this.currentCategory = Object.assign({}, this.categoryTemplate())
    },
    createType() {
      this.typeTabs = '0'
      this.dialogType = true
      this.currentType = Object.assign({}, this.typeTemplate())
    },
    verifyContent(item) {
      let result = true
      let message = []

      let defaultLangId = this.$store.state.languages.defaultLangId
      const spanishLang = item.name.find(lang => lang.langId === defaultLangId)
      if (!spanishLang || !spanishLang.text) {
        error = true
        message.push(this.$t('error.nameSpanish'))
      }

      if (!item.order) {
        result = false
        message.push(this.$t('error.required', { field: this.$tc('order') }))
      }
      return {
        result,
        message
      }
    }
  }
}
</script>
